module.exports = __webpack_public_path__ + "img/image01_sp.88d3d5e6.jpg";